// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SettingsRow_wrap__PooLU","title":"SettingsRow_title__2FreA","subtitle":"SettingsRow_subtitle__3Lwi1","content":"SettingsRow_content__34J5Z"};